'use client';

import { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import {
  getBrandAboutUrl,
  getBrandTeamUrl,
  getBrandCareersUrl,
  getBrandContactUrl,
  getBrandInvestorsUrl,
  getCreatorLoginUrl,
  getCreatorRegisterUrl,
} from '@/lib/creatorPlatformUrls';
import AgreementDrawer from '@/components/AgreementDrawer';
import SiteBeianLinks from '@/components/SiteBeianLinks';

type AgreementDrawerType = 'terms-of-service' | 'privacy-policy';
type MediaKey = 'wechat' | 'xiaohongshu' | null;

const MEDIA_ITEMS: Array<{ key: MediaKey; label: string; logo: string; qr: string }> = [
  { key: 'wechat', label: '微信公众号', logo: '/home/media/wechat-logo.png', qr: '/home/media/our-wechat.png' },
  { key: 'xiaohongshu', label: '小红书', logo: '/home/media/xiaohongshu_logo.png', qr: '/home/media/our-xiaohongshu.jpg' },
];

export default function MarketingFooter() {
  const [agreementDrawerOpen, setAgreementDrawerOpen] = useState(false);
  const [agreementType, setAgreementType] = useState<AgreementDrawerType>('terms-of-service');
  const [activeMedia, setActiveMedia] = useState<MediaKey>(null);
  const mediaRef = useRef<HTMLDivElement>(null);

  const openAgreement = (type: AgreementDrawerType) => {
    setAgreementType(type);
    setAgreementDrawerOpen(true);
  };

  useEffect(() => {
    if (!activeMedia) return;
    const close = (e: MouseEvent) => {
      if (mediaRef.current && !mediaRef.current.contains(e.target as Node)) setActiveMedia(null);
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [activeMedia]);

  return (
    <footer className="home-footer">
      <div className="home-footer-inner">
        <div className="home-footer-col">
          <div className="home-footer-col-title">关于我们</div>
          <Link href={getBrandAboutUrl()}>品牌介绍</Link>
          <Link href={getBrandTeamUrl()}>创始团队</Link>
          <Link href={getBrandCareersUrl()}>加入我们</Link>
          <Link href={getBrandContactUrl()}>联系我们</Link>
        </div>
        <div className="home-footer-col">
          <div className="home-footer-col-title">产品服务</div>
          <Link href={getCreatorLoginUrl()}>创作者平台</Link>
          <Link href={getBrandInvestorsUrl()}>更多产品服务</Link>
          <Link href={getCreatorLoginUrl()}>登录</Link>
          <Link href={getCreatorRegisterUrl()}>注册</Link>
        </div>
        <div className="home-footer-col">
          <div className="home-footer-col-title">法律</div>
          <button type="button" className="home-footer-col-link" onClick={() => openAgreement('terms-of-service')}>
            服务条款
          </button>
          <button type="button" className="home-footer-col-link" onClick={() => openAgreement('privacy-policy')}>
            隐私政策
          </button>
        </div>
        <div className="home-footer-col home-footer-media" ref={mediaRef}>
          <div className="home-footer-col-title">媒体</div>
          <div className="home-footer-media-items">
            {MEDIA_ITEMS.map(({ key, label, logo, qr }) => (
              <div
                key={key}
                className={`home-footer-media-item${activeMedia === key ? ' is-active' : ''}`}
              >
                <button
                  type="button"
                  className="home-footer-media-logo"
                  aria-label={label}
                  onClick={() => setActiveMedia(activeMedia === key ? null : key)}
                >
                  <img src={logo} alt="" width={28} height={28} />
                </button>
                <div className="home-footer-media-qr" aria-hidden>
                  <img src={qr} alt={label} width={220} height={220} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <p className="home-footer-copy">© {new Date().getFullYear()} 基音 · 拉凡达（上海）科技有限责任公司. 保留所有权利.</p>
      <SiteBeianLinks className="home-footer-beian site-beian-links" />
      <AgreementDrawer
        isOpen={agreementDrawerOpen}
        onClose={() => setAgreementDrawerOpen(false)}
        agreementType={agreementType}
      />
    </footer>
  );
}
